import Toast from './toast'

export default Toast



// WEBPACK FOOTER //
// ./src/components/toast/index.js